import { endpoints, baseurl } from "../Utils/Constants";

export const saveTracking = async (data, token) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_TRACKING, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        console.error("Error saving tracking:", error);
        throw error;
    }
};

const parseTrackingByIdParams = (id) => {
    const decoded = decodeURIComponent(id || '');
    if (!decoded) {
        return { providerId: '', healthcarePayorId: '' };
    }

    const delimiter = decoded.includes('~') ? '~' : decoded.includes('-') ? '-' : null;
    if (!delimiter) {
        return { providerId: decoded, healthcarePayorId: '' };
    }

    const [providerId, ...payorParts] = decoded.split(delimiter);
    return {
        providerId: providerId || '',
        healthcarePayorId: payorParts.join(delimiter) || '',
    };
};

export const getTrackingById = async (id, token) => {
    try {
        const { providerId, healthcarePayorId } = parseTrackingByIdParams(id);
        const url =
            providerId && healthcarePayorId
                ? `${baseurl + endpoints.GET_TRACKING_BY_ID}${providerId}/${healthcarePayorId}`
                : `${baseurl + endpoints.GET_TRACKING_BY_ID}${id}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error(`Error fetching tracking with ID ${id}:`, error);
        throw error;
    }
};

export const getAllTrackings = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_TRACKING, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching trackings:", error);
        throw error;
    }
};

export const deleteTracking = async (id, token) => {
    try {
        const { providerId, healthcarePayorId } = parseTrackingByIdParams(id);
        const url =
            providerId && healthcarePayorId
                ? `${baseurl + endpoints.DELETE_TRACKING}${providerId}/${healthcarePayorId}`
                : `${baseurl + endpoints.DELETE_TRACKING}${id}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error(`Error deleting tracking with ID ${id}:`, error);
        throw error;
    }
};

export const getAllFollowUps = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_FOLLOW_UPS, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching follow-ups:", error);
        throw error;
    }
};